import React, { useEffect, useRef } from 'react';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { Error } from '../contexts/Error';

interface ShowPromptProperties {
  error?: Error;
  onClose: () => void;
}
const getPrompt = (onClose: () => void, error?: Error): JSX.Element | null => {
  if (!error) return null;
  const { title, text, btnText } = error;
  const footer = (
    <ModalFooter>
      <Button text={btnText} type="primary" onClick={onClose} />
    </ModalFooter>
  );
  return (
    <Prompt title={title} footer={footer}>
      <p>{text}</p>
    </Prompt>
  );
};

export const ShowErrorItem: React.FC<ShowPromptProperties> = ({
  error,
  onClose,
}) => {
  const triggerRef = useRef<HTMLElement | null>(null);
  const wasOpenRef = useRef(false);

  // Capture the element that had focus only on the closed->open transition
  useEffect(() => {
    if (error && !wasOpenRef.current) {
      triggerRef.current = document.activeElement as HTMLElement;
    }
    wasOpenRef.current = !!error;
  }, [error]);

  const handleModalClosed = (): void => {
    triggerRef.current?.focus();
  };

  return (
    <Modal
      visible={!!error}
      escapable={true}
      handleCloseBtn={onClose}
      onModalClosed={handleModalClosed}
    >
      {getPrompt(onClose, error)}
    </Modal>
  );
};
